import {
    CONTENTITEM_TYPE_STORY,
    CONTENTITEM_TYPE_BLOGENTRY,
    CONTENTITEM_TYPE_EPISODE,
    CONTENTITEM_TYPE_SEGMENT,
    CONTENTITEM_TYPE_FEATURE,
    CONTENTITEM_TYPE_SPONSORED_CONTENT,
} from "../../pages/Detail/constants";

const VALID_TYPES = [
    "AdvertiserContentArticle",
    "AudioObject",
    "BlogPosting",
    "Clip",
    "CorrectionComment",
    "Episode",
    "Event",
    "ImageObject",
    "LiveBlogPosting",
    "NewsArticle",
    "NewsMediaOrganization",
    "Organization",
    "Person",
    "Recipe",
    "ReportageNewsArticle",
    "VideoObject",
    "WebPage",
];

const PUBLISHER_MAIN_LINK = "https://www.cbc.ca/news/about-cbc-news-1.1294364";

const SOCIAL_MEDIA_LINKS = [
    "https://www.facebook.com/cbc/",
    "https://x.com/cbc/",
    "https://www.youtube.com/@CBC",
    "https://www.instagram.com/cbc/?hl=en",
    "https://www.tiktok.com/@cbc?lang=en",
];

export const SCHEMA_TYPES = VALID_TYPES.reduce((accumulator, currentType) => {
    accumulator[currentType] = { "@type": currentType };
    return accumulator;
}, {});

export const SCHEMA_CONTEXT = { "@context": "https://schema.org" };

export const SCHEMA_PUBLISHER_ID = {
    "@id": "https://www.cbc.ca/#publisher",
};

export const SCHEMA_AUTHOR_CBC = {
    ...SCHEMA_TYPES.NewsMediaOrganization,
    url: "https://www.cbc.ca",
    name: "CBC",
};

export const SCHEMA_PUBLISHER = {
    ...SCHEMA_CONTEXT,
    ...SCHEMA_AUTHOR_CBC,
    ...SCHEMA_PUBLISHER_ID,
    logo: "https://i.cbc.ca/1.4066392.1541713557!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/cbc-logo-horizontal.jpg",
    foundingDate: "1936-11-02",
    ethicsPolicy: PUBLISHER_MAIN_LINK,
    verificationFactCheckingPolicy: PUBLISHER_MAIN_LINK,
    ownershipFundingInfo: PUBLISHER_MAIN_LINK,
    actionableFeedbackPolicy: PUBLISHER_MAIN_LINK,
    missionCoveragePrioritiesPolicy: PUBLISHER_MAIN_LINK,
    diversityPolicy: PUBLISHER_MAIN_LINK,
    masthead: PUBLISHER_MAIN_LINK,
    diversityStaffingReport: PUBLISHER_MAIN_LINK,
    unnamedSourcesPolicy: PUBLISHER_MAIN_LINK,
    correctionsPolicy: PUBLISHER_MAIN_LINK,
    sameAs: SOCIAL_MEDIA_LINKS,
};

export const CONTENTITEM_MAPPING_TO_SCHEMA_TYPE = {
    [CONTENTITEM_TYPE_STORY]: SCHEMA_TYPES.ReportageNewsArticle,
    [CONTENTITEM_TYPE_BLOGENTRY]: SCHEMA_TYPES.BlogPosting,
    [CONTENTITEM_TYPE_EPISODE]: SCHEMA_TYPES.Episode,
    [CONTENTITEM_TYPE_SEGMENT]: SCHEMA_TYPES.Clip,
    [CONTENTITEM_TYPE_FEATURE]: SCHEMA_TYPES.NewsArticle,
    [CONTENTITEM_TYPE_SPONSORED_CONTENT]: SCHEMA_TYPES.AdvertiserContentArticle,
};
